import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=e2c5a26e&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2c5a26e')) {
      api.createRecord('e2c5a26e', component.options)
    } else {
      api.reload('e2c5a26e', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=e2c5a26e&", function () {
      api.rerender('e2c5a26e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2btxGZi0FcoWy/JS/pricehelp.vue"
export default component.exports